import createTableHead from './createTableHead';

// ----------------------------------------------------------------------------

function alreadyTableHead(element: HTMLElement, config?: Record<string, any>): HTMLTableSectionElement {
    let elTableHead = element.querySelector('thead') as HTMLTableSectionElement | undefined;

    if (!elTableHead) {
        elTableHead = createTableHead(config);
        element.prependChild(elTableHead);
    }

    return elTableHead;
}

// ----------------------------------------------------------------------------

export default alreadyTableHead;
